import React from 'react';
import { useDispatch } from 'react-redux';

import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { alpha, lighten, styled } from '@mui/material/styles';

import { setSelectedFlow } from '../../../../../actions/casesActions';
import { procedureFlows, selectedProcedureFlows } from '../../../../../constants/cases';

import hto_image from '../../../../../assets/step0/PS_HTO_Image.png';
import dfo_image from '../../../../../assets/step0/PS_DFO_Image.png';
import double_level_image from '../../../../../assets/step0/PS_double_level.png';

const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  width: '100%',
  height: '100%',
  backgroundColor: theme.palette.background.paper,

  '& .block-header': {
    width: '90%',
    marginTop: 10,
    marginBottom: 25,
  },
}));

const StyledListItem = styled(ListItem)(({ selected, theme }) => ({
  borderRadius: 20,
  border: '2px solid #ee9321',
  cursor: 'pointer',
  color: theme.palette.text.primary,
  backgroundColor: selected
    ? `${theme.palette.mode === 'dark'
      ? alpha('#ee9321', 0.32)
      : lighten('#ee9321', 0.95)} !important`
    : 'var(--color-surface)',
  '& .MuiListItemText-primary, & .MuiListItemText-secondary': {
    color: selected
      ? (theme.palette.mode === 'dark' ? theme.palette.text.primary : undefined)
      : undefined,
  },
  '& img': {
    filter: selected && theme.palette.mode !== 'dark' ? 'brightness(1.05) contrast(1.05)' : 'none',
  },
}));

const StyledListItemText = styled(ListItemText)(({ theme }) => ({
  '& .MuiListItemText-primary': {
    fontSize: '1.2rem',
    fontWeight: 600,
    letterSpacing: 1.5,
    color: theme.palette.text.primary,
  },
  '& .MuiListItemText-secondary': {
    fontSize: '0.9rem',
    color: theme.palette.text.secondary,
  },
}));

export const Step0Osteotomy = ({ selected, onChange, procedures = [] }) => {
  const dispatch = useDispatch();

  const handleProcedureFlowClick = (event, flow) => {
    onChange(flow);
    dispatch(setSelectedFlow(flow));
  };

  return (
    <Container>
      <div className="block-header">Select Procedure</div>

      <Grid container sx={{ width: '95%' }} spacing={3}>
        {procedures.some(
          (procedure) =>
            procedure.flow === procedureFlows.HTO ||
            procedure.flow === procedureFlows.HTO_LATERAL,
        ) && (
          <Grid item size={{ xs: 12, md: 6 }}>
            <StyledListItem
              button
              selected={selected === selectedProcedureFlows.HTO}
              onClick={(event) => handleProcedureFlowClick(event, selectedProcedureFlows.HTO)}
              backgroundColor="#ee9321"
            >
              <img src={hto_image} alt="HTO" width="80" height="80" />
              <StyledListItemText
                primary="HTO"
                secondary="High Tibial Osteotomy"
              />
            </StyledListItem>
          </Grid>
        )}

        {procedures.some(
          (procedure) =>
            procedure.flow === procedureFlows.DFO_Lateral ||
            procedure.flow === procedureFlows.DFO_Medial,
        ) && (
          <Grid item size={{ xs: 12, md: 6 }}>
            <StyledListItem
              button
              selected={selected === selectedProcedureFlows.DFO}
              onClick={(event) => handleProcedureFlowClick(event, selectedProcedureFlows.DFO)}
            >
              <img src={dfo_image} alt="DFO" width="80" height="80" />
              <StyledListItemText
                primary="DFO"
                secondary="Distal Femoral Osteotomy"
              />
            </StyledListItem>
          </Grid>
        )}

        {procedures.some((procedure) => procedure.flow === procedureFlows.DOUBLE_LEVEL_OSTEOTOMY) && (
          <Grid item size={{ xs: 12, sm: 6 }}>
            <StyledListItem
              button
              selected={selected === selectedProcedureFlows.DOUBLE_LEVEL_OSTEOTOMY}
              onClick={(event) =>
                handleProcedureFlowClick(event, selectedProcedureFlows.DOUBLE_LEVEL_OSTEOTOMY)
              }
            >
              <img
                src={double_level_image}
                alt="DOUBLE LEVEL OSTEOTOMY"
                width="80"
                height="80"
              />
              <StyledListItemText
                primary="DOUBLE LEVEL OST."
                secondary="Combination HTO & DFO Procedure"
              />
            </StyledListItem>
          </Grid>
        )}
      </Grid>
    </Container>
  );
};
